module.exports = __webpack_public_path__ + "87b8b00eb9a9f6322381e57167d3e1fb.svg";